import CyberGlobe from './CyberGlobe';
export default function App() { return <CyberGlobe />; }